export { default } from "./RetailerInfoSection";
